// ajay:code all file this 24-07-26
import { useNavigate } from "react-router-dom";
import { LayoutTemplate, Eye } from "lucide-react";

// Static registry of SPC templates. Only one exists today (Weight); more
// (Diameter, CD, Dimension...) can be added here later without touching
// the view page, as long as they follow the same { id, name, parameter,
// unit, status } shape.
const TEMPLATES = [
  {
    id: "weight-spc",
    name: "Weight SPC (Cp/Cpk)",
    parameter: "Weight",
    unit: "g",
    status: "Active",
  },
];

export default function Templates() {
  const navigate = useNavigate();

  return (
    <div style={{ padding: 28 }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          marginBottom: 24,
        }}
      >
        <div>
          <h1 style={{ fontSize: 20, fontWeight: 700 }}>Templates</h1>
          <p style={{ color: "var(--text2)", fontSize: 13, marginTop: 2 }}>
            SPC / Cp-Cpk report templates
          </p>
        </div>
      </div>

      <div className="card" style={{ padding: 0, overflow: "hidden" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ borderBottom: "1px solid var(--border)" }}>
              {["SR.NO", "TEMPLATE NAME", "PARAMETER", "STATUS", "ACTIONS"].map(
                (h) => (
                  <th
                    key={h}
                    style={{
                      textAlign: "left",
                      padding: "12px 16px",
                      fontSize: 11,
                      fontWeight: 700,
                      letterSpacing: "0.06em",
                      color: "var(--text3)",
                    }}
                  >
                    {h}
                  </th>
                ),
              )}
            </tr>
          </thead>
          <tbody>
            {TEMPLATES.map((t, i) => (
              <tr
                key={t.id}
                style={{ borderBottom: "1px solid var(--border)" }}
              >
                <td
                  style={{
                    padding: "14px 16px",
                    fontSize: 13,
                    color: "var(--text2)",
                  }}
                >
                  {i + 1}
                </td>
                <td
                  style={{
                    padding: "14px 16px",
                    fontSize: 13,
                    fontWeight: 600,
                  }}
                >
                  <div
                    style={{ display: "flex", alignItems: "center", gap: 8 }}
                  >
                    <LayoutTemplate size={14} color="var(--accent)" />
                    {t.name}
                  </div>
                </td>
                <td
                  style={{
                    padding: "14px 16px",
                    fontSize: 13,
                    color: "var(--text2)",
                  }}
                >
                  {t.parameter} ({t.unit})
                </td>
                <td style={{ padding: "14px 16px" }}>
                  <span
                    className={`badge ${t.status === "Active" ? "badge-success" : "badge-danger"}`}
                  >
                    {t.status}
                  </span>
                </td>
                <td style={{ padding: "14px 16px" }}>
                  <button
                    title="View"
                    onClick={() => navigate(`/company/templates/${t.id}`)}
                    style={{
                      background: "var(--surface2)",
                      border: "1px solid var(--border)",
                      borderRadius: 6,
                      padding: 6,
                      cursor: "pointer",
                      color: "var(--text2)",
                      display: "flex",
                    }}
                  >
                    <Eye size={15} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
